export const LANDING_PAGES_ABOUT_SECTION_DESCRIPTION_TITLE = 'What we do';
export const LANDING_PAGES_ABOUT_SECTION_DESCRIPTION_TEXT = [
  'Select the background image and short paragraph that will go with your About Section on the Home Page.',
];

export const LANDING_PAGES_HEADER_DESCRIPTION_TITLE = 'Header';
export const LANDING_PAGES_HEADER_DESCRIPTION_TEXT = [
  'Select the background image, title and subtitle that you wish to use for the Home Page Header.',
];

export const LANDING_PAGES_TEAM_SECTION_DESCRIPTION_TITLE = 'Who we are';
export const LANDING_PAGES_TEAM_SECTION_DESCRIPTION_TEXT = [
  'Select the background image and short paragraph that will go with your Team Section on the Home Page.',
];

export const LANDING_PAGES_EMPLOYEES_SECTION_DESCRIPTION_TITLE = 'Employees';
export const LANDING_PAGES_EMPLOYEES_SECTION_DESCRIPTION_TEXT = [
  'Show off your amazing team with each individuals picture, name, and role.',
];

export const LANDING_PAGES_TEAM_HEADER_DESCRIPTION_TITLE = 'Header';
export const LANDING_PAGES_TEAM_HEADER_DESCRIPTION_TEXT = [
  'Select the background image, title and subtitle that you wish to use for the Home Page Header.',
];

export const LANDING_PAGES_PRICING_HEADER_DESCRIPTION_TEXT = 'Header';
export const LANDING_PAGES_PRCING_HEADER_DESCRIPTION_TITLE = [
  'Select the subscriptions that your customers can select',
];

export const LANDING_PAGES_SUBSCRIPTIONS_SECTION_DESCRIPTION_TITLE =
  'Subscriptions';
export const LANDING_PAGES_SUBSCRIPTIONS_SECTION_DESCRIPTION_TEXT = [
  'Subscriptions are services that you charge for on a recurring basis',
];
